
import { defineComponent } from 'vue'
import { createValidations, ICustomValidatorMap } from '@/helpers/commons/validationHelper'
import useValidate from '@vuelidate/core'
import KnValidationMessages from '@/components/UI/KnValidatonMessages.vue'
import ckanDescriptor from './DatasetManagementCkanDatasetDescriptor.json'
import Dropdown from 'primevue/dropdown'
import Card from 'primevue/card'

export default defineComponent({
    components: { Card, Dropdown, KnValidationMessages },
    props: { selectedDataset: { type: Object as any } },
    emits: ['touched'],
    data() {
        return {
            v$: useValidate() as any,
            ckanDescriptor,
            dataset: {} as any,
            ckanDateFormat: ckanDescriptor.ckanDateFormat,
            availableFileTypes: ckanDescriptor.ckanFileTypes,
            csvEncodingTypes: ckanDescriptor.csvEncodingTypes,
            csvQuoteCharacterTypes: ckanDescriptor.csvQuoteCharacterTypes,
            csvDelimiterCharacterTypes: ckanDescriptor.csvDelimiterCharacterTypes
        }
    },
    created() {
        this.dataset = this.selectedDataset
    },
    watch: {
        selectedDataset() {
            this.dataset = this.selectedDataset
        }
    },
    validations() {
        const ckanFieldsRequired = (value) => {
            return this.dataset.dsTypeCd != 'Ckan' || value
        }
        const csvFieldsRequired = (value) => {
            return this.dataset.ckanFileType != 'CSV' || value
        }
        const customValidators: ICustomValidatorMap = { 'ckan-fields-required': ckanFieldsRequired, 'csv-fields-required': csvFieldsRequired }
        const validationObject = { dataset: createValidations('dataset', ckanDescriptor.validations.dataset, customValidators) }
        return validationObject
    },
    methods: {}
})
